import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ScoreNumerator = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${30 * Screen.widthRatio}px;
  height: ${40 * Screen.widthRatio}px;
  line-height: ${46 * Screen.widthRatio}px;
  margin-left: ${18 * Screen.widthRatio}px;
`;

export default ScoreNumerator;
